import React, { useState, useEffect } from 'react';
import '../styles/experiencesection.css';
import db from "../scripts/firebase";
import { useInView } from '../hooks/useInView';
import ExperienceItem from './ExperienceItem';
import OtherExperienceItem from './OtherExperienceItem';

import ResumeFile from '../img/DarylDang.pdf'

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August",
                    "September", "October", "November", "December"];

const ExperienceSection = () => {
    const [resumeDownloaded, setResumeDownloaded] = useState(false);
    const [myExperiences, setMyExperiences] = useState({});
    const [myOtherExperiences, setMyOtherExperiences] = useState({});

    const fetchExperiences = async () => {
        var temp = [];

        await db.collection("experiences").orderBy("start_date", "desc").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                temp.push((doc.data()));
                setMyExperiences({
                    data: temp
                });
            });
        })
    };

    const fetchOtherExperiences = async () => {
        var temp = [];

        await db.collection("other_experiences").orderBy("end_date", "desc").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                temp.push((doc.data()));
                setMyOtherExperiences({
                    data: temp
                });
            });
        })
    };

    const getExperienceCarouselItems = () => {
        if (myExperiences.data == null) {
            return
        }


        // sort experience items by start date and considering end date (if the end date is before the start date, they are considered present)
        var tempData = []
        var presentData = []
        for(var i = 0; i < myExperiences.data.length; i++) {
            var d = myExperiences.data[i];
            if(d.end_date.seconds < d.start_date.seconds) {
                presentData.push(d);
            }
            else {
                tempData.push(d);
            }
        }

        presentData.sort((a, b) => a.start_date.seconds - b.start_date.seconds);

        myExperiences.data = presentData.concat(tempData);

        var experienceItems = [];
        myExperiences.data.forEach((d) => {
            experienceItems.push(
                <ExperienceItem key={d.company} experience={d} monthNames={monthNames} />
            );
        });
        return experienceItems;
    };

    const getOtherExperienceCarouselItems = () => {
        if (myOtherExperiences.data == null) {
            return
        }

        var otherExperienceItems = [];
        myOtherExperiences.data.forEach((d) => {
            otherExperienceItems.push(
                <OtherExperienceItem key={d.name} experience={d} monthNames={monthNames} />
            );
        });
        return otherExperienceItems;
    };

    useEffect(() => {
        fetchExperiences();
        fetchOtherExperiences();
    }, []);

    const { ref: titleRef, inView: titleInView } = useInView();
    const { ref: resumeRef, inView: resumeInView } = useInView();
    const { ref: subtitleRef1, inView: subtitleInView1 } = useInView();
    const { ref: subtitleRef2, inView: subtitleInView2 } = useInView();

    return (
        <React.Fragment>
            <div id='experience'>
                <div className="navbar-spacer"><p></p></div>
                <h1
                    className={`section-title fade-in-left ${titleInView ? 'animation-active' : ''}`}
                    ref={titleRef}>
                    Experience
                </h1>
                {resumeDownloaded?
                <div className='download-button'>
                    <a className='downloaded-text'>✔️</a>
                </div>
                :
                <div
                className={`download-button fade-in hover-scale-lg ${resumeInView ? 'animation-active' : ''}`}
                onClick={() => setResumeDownloaded(true)}
                ref={resumeRef}>
                    <a className='download-text' href={ResumeFile} download="DarylDangResume">
                        Resume
                    </a>
                </div>
                }
                <h2
                    className={`sub-title fade-in-left ${subtitleInView1 ? 'animation-active' : ''}`}
                    ref={subtitleRef1}
                    style={{animationDelay: '0.2s'}}>
                    Professional Work Experiences
                </h2>
                <div className='experience-container'>{getExperienceCarouselItems()}</div>
                <div className="section-spacer"></div>
                <h2
                    className={`sub-title fade-in-left ${subtitleInView2 ? 'animation-active' : ''}`}
                    ref={subtitleRef2}
                    style={{animationDelay: '0.2s'}}>
                    Other Experiences
                </h2>
                <div className='experience-container'>{getOtherExperienceCarouselItems()}</div>
                <div className="section-spacer"></div>
            </div>
        </React.Fragment>
    );

}
export default ExperienceSection;